<app-title-bar rootBreadCrumbs="['i18n.core.navigation.manual-import']"
  titleText="i18n.core.navigation.{{ImportType[importType]}}"></app-title-bar>
<div class="row">
  <div class="col-2 line-right">
    <div class="row">
      <div class="col-12">
        <h3>{{ 'i18n.domain.manual-import.fill-template' | translate }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button type="reset" (click)="downloadTemplate()" class="btn btn-outline-secondary btn-fixedw rounded">
          {{ 'i18n.domain.manual-import.download-template' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="col-4 line-right">
    <div class="row">
      <div class="col-12">
        <h3>{{ 'i18n.domain.manual-import.upload-file' | translate }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <div appMessageDirective [variant]="MessageVariant.Outlined" [severity]="MessageSeverity.LBColors">{{ 'i18n.domain.manual-import.upload-hint' | translate }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div #dropArea id='dropArea'>
          <ejs-uploader #defaultupload [asyncSettings]="asyncSettings" [multiple]="false" [autoUpload]="true"
            (selected)="onFileSelected($event)" (uploading)="onUploading($event)" (canceling)="onCanceling($event)"
            (removing)="onRemoving($event)" (success)="onUploadSuccess($event)" (failure)="onUploadFailed($event)"
            (removing)="onRemoving($event)" [dropArea]='dropArea' allowedExtensions=".xlsx">
          </ejs-uploader>
        </div>
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="row">
      <div class="col-12">
        <h3>{{ 'i18n.domain.manual-import.import' | translate }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <span>{{'i18n.domain.manual-import.state' | translate }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <span>{{'i18n.domain.manual-import.log' | translate }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ejs-grid #grid class="grid" rowHeight="38" [dataSource]="protocols">
          <e-columns>
            <e-column field="id" [visible]="false" [isPrimaryKey]="true">
            </e-column>
            <e-column field="createdOn" headerText="{{'i18n.domain.manual-import.log-grid.timestamp' | translate}}"
              clipMode="EllipsisWithTooltip" type="date" format="dd.MM.yyyy HH:mm:ss" [allowFiltering]="false"
              width="20%">
            </e-column>
            <e-column field="logStatus" headerText="{{'i18n.domain.manual-import.log-grid.state' | translate}}"
              clipMode="EllipsisWithTooltip" [allowSorting]="false">
              <ng-template #template let-data>
                {{formatEntryState(data.logStatus)}}
              </ng-template>
            </e-column>
            <e-column field="errorLineNumber" headerText="{{'i18n.domain.manual-import.log-grid.row' | translate}}"
              clipMode="EllipsisWithTooltip" [allowSorting]="false">
            </e-column>
            <e-column field="statusMessage" headerText="{{'i18n.domain.manual-import.log-grid.message' | translate}}"
              clipMode="EllipsisWithTooltip" [allowFiltering]="false" [allowSorting]="false" width="50%">
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</div>
